var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgExamSetCompetition = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59961 4H15.2996V6.6H8.59961V4Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60009 4L7.00009 5.2C6.50009 5.6 6.30009 6.4 6.70009 7L9.30009 11.1L12.1001 9.4L8.60009 4Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4004 4L17.0004 5.2C17.6004 5.6 17.7004 6.4 17.3004 7L14.7004 11.1L11.9004 9.4L15.4004 4Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.4008C17.5 17.5008 15 20.0008 12 20.0008C9 20.0008 6.5 17.5008 6.5 14.4008C6.5 11.3008 9 8.80078 12 8.80078C15 8.80078 17.5 11.3008 17.5 14.4008Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1004 14.3992C16.1004 16.6992 14.2004 18.5992 12.0004 18.5992C9.80039 18.5992 7.90039 16.6992 7.90039 14.3992C7.90039 12.0992 9.70039 10.1992 12.0004 10.1992C14.3004 10.1992 16.1004 12.0992 16.1004 14.3992Z",
    fill: "#FFDB59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3002 13.4008L13.0002 13.2008L12.5002 12.1008C12.4002 11.9008 12.3002 11.8008 12.1002 11.8008C12.0002 11.8008 11.8002 11.9008 11.7002 12.1008L11.2002 13.2008L9.90016 13.4008C9.60016 13.4008 9.40016 13.9008 9.70016 14.1008L10.6002 15.0008L10.4002 16.3008C10.3002 16.6008 10.7002 16.9008 11.0002 16.7008L12.1002 16.1008L13.2002 16.7008C13.5002 16.9008 13.9002 16.6008 13.8002 16.3008L13.6002 15.0008L14.5002 14.1008C14.8002 13.9008 14.6002 13.5008 14.3002 13.4008Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.0871,
    y1: -0.2546,
    x2: 11.9543,
    y2: 7.9815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.80109,
    y1: 2.9742,
    x2: 9.73099,
    y2: 12.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 17.2729,
    y1: 2.6979,
    x2: 12.6234,
    y2: 12.2624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 6.4763,
    y1: 7.39938,
    x2: 18.1663,
    y2: 22.2112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 9.58936,
    y1: 6.39698,
    x2: 12.9104,
    y2: 16.2936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamSetCompetition, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExamSetCompetition.875f0fe6.svg";
export { ForwardRef as ReactComponent };